// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.top-nav-search {
  position: relative;
  width: clamp(18rem, 28vw, 32rem);
}

.top-nav-search__input-wrap {
  height: 2.35rem;
  border-radius: 999px;
  background: #f3f6fb;
  border: 1px solid #d9e2ee;
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.top-nav-search__input-wrap:focus-within {
  border-color: #94b8e6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

.top-nav-search__icon {
  color: #64748b;
  width: 1rem;
  height: 1rem;
  flex: 0 0 auto;
}

.top-nav-search__input {
  border: 0;
  background: transparent;
  width: 100%;
  margin-left: 0.5rem;
  color: #1f2937;
}

.top-nav-search__input:focus {
  outline: none;
}

.top-nav-search__dropdown {
  position: absolute;
  top: calc(100% + 0.35rem);
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  padding: 0.3rem;
  z-index: 1200;
}

.top-nav-search__group + .top-nav-search__group {
  margin-top: 0.25rem;
  padding-top: 0.25rem;
  border-top: 1px solid #e2e8f0;
}

.top-nav-search__group-title {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
  padding: 0.35rem 0.65rem 0.25rem;
}

.top-nav-search__result {
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  border-radius: 0.55rem;
  padding: 0.5rem 0.65rem;
  color: #1f2937;
  transition: background-color 100ms ease, color 100ms ease;
}

.top-nav-search__result:hover,
.top-nav-search__result:focus-visible {
  background: #eef4ff;
  color: #0f2f52;
  outline: none;
}

.top-nav-search__result--deep {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.top-nav-search__result-title {
  font-weight: 600;
}

.top-nav-search__result-subtitle {
  color: #334155;
  font-size: 0.82rem;
}

.top-nav-search__result-meta {
  color: #64748b;
  font-size: 0.76rem;
}

.top-nav-search__result--disabled {
  color: #94a3b8;
  cursor: default;
}

@media (max-width: 1190px) {
  .top-nav-search {
    width: clamp(14rem, 44vw, 22rem);
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/components/top-nav-search/top-nav-search.component.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;AADJ;;AAIA;EACI,kBAAA;EACA,gCAAA;AADJ;;AAIA;EACI,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0DAAA;AADJ;;AAIA;EACI,qBAAA;EACA,8CAAA;AADJ;;AAIA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AADJ;;AAIA;EACI,SAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,kBAAA;EACA,yBAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8CAAA;EACA,eAAA;EACA,aAAA;AADJ;;AAIA;EACI,mBAAA;EACA,oBAAA;EACA,6BAAA;AADJ;;AAIA;EACI,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gCAAA;AADJ;;AAIA;EACI,WAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,yDAAA;AADJ;;AAIA;;EAEI,mBAAA;EACA,cAAA;EACA,aAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,cAAA;EACA,kBAAA;AADJ;;AAIA;EACI,cAAA;EACA,kBAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;AADJ;;AAIA;EACI;IACI,gCAAA;EADN;AACF","sourcesContent":["@import 'styles/core/variables.scss';\n\n:host {\n    display: block;\n}\n\n.top-nav-search {\n    position: relative;\n    width: clamp(18rem, 28vw, 32rem);\n}\n\n.top-nav-search__input-wrap {\n    height: 2.35rem;\n    border-radius: 999px;\n    background: #f3f6fb;\n    border: 1px solid #d9e2ee;\n    display: flex;\n    align-items: center;\n    padding: 0 0.75rem;\n    transition: border-color 120ms ease, box-shadow 120ms ease;\n}\n\n.top-nav-search__input-wrap:focus-within {\n    border-color: #94b8e6;\n    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n\n.top-nav-search__icon {\n    color: #64748b;\n    width: 1rem;\n    height: 1rem;\n    flex: 0 0 auto;\n}\n\n.top-nav-search__input {\n    border: 0;\n    background: transparent;\n    width: 100%;\n    margin-left: 0.5rem;\n    color: #1f2937;\n}\n\n.top-nav-search__input:focus {\n    outline: none;\n}\n\n.top-nav-search__dropdown {\n    position: absolute;\n    top: calc(100% + 0.35rem);\n    left: 0;\n    width: 100%;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.75rem;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n    padding: 0.3rem;\n    z-index: 1200;\n}\n\n.top-nav-search__group + .top-nav-search__group {\n    margin-top: 0.25rem;\n    padding-top: 0.25rem;\n    border-top: 1px solid #e2e8f0;\n}\n\n.top-nav-search__group-title {\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: #64748b;\n    padding: 0.35rem 0.65rem 0.25rem;\n}\n\n.top-nav-search__result {\n    width: 100%;\n    border: 0;\n    background: transparent;\n    text-align: left;\n    border-radius: 0.55rem;\n    padding: 0.5rem 0.65rem;\n    color: #1f2937;\n    transition: background-color 100ms ease, color 100ms ease;\n}\n\n.top-nav-search__result:hover,\n.top-nav-search__result:focus-visible {\n    background: #eef4ff;\n    color: #0f2f52;\n    outline: none;\n}\n\n.top-nav-search__result--deep {\n    display: flex;\n    flex-direction: column;\n    gap: 0.1rem;\n}\n\n.top-nav-search__result-title {\n    font-weight: 600;\n}\n\n.top-nav-search__result-subtitle {\n    color: #334155;\n    font-size: 0.82rem;\n}\n\n.top-nav-search__result-meta {\n    color: #64748b;\n    font-size: 0.76rem;\n}\n\n.top-nav-search__result--disabled {\n    color: #94a3b8;\n    cursor: default;\n}\n\n@media (max-width: 1190px) {\n    .top-nav-search {\n        width: clamp(14rem, 44vw, 22rem);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
